module.exports = __webpack_public_path__ + "img/00s_pack.a21aa4b3.png";